import { IoArrowBack } from "react-icons/io5";
import "./BookingAppointmentCss/BasicInfoSection.css";
import {
  convertToMMDDYYYY,
  formatDate,
  getIosDateString,
} from "../../utils/helper";
import { useState } from "react";
import { getUserData, getUserMobile } from "../../utils/auth";
import DatePicker from "react-datepicker";
export default function BasicInfoSection({
  onNext,
  onBack,
  formData,
  handleChange,
  profileData,
  handlePatientChange,
  selectedPatient,
  handleBookAppointment,
  showPatientType,
  setSelectedPatient,
  setFormData,
  isOtpverified,
  errors,
  setErrors,
  patientType,
  setPatientType,
} = {}) {
  // const [patientType, setPatientType] = useState("");
  const isLoggedin = Boolean(getUserData());
  const mobileData = getUserMobile();
  return (
    <>
      <div className="step1-container">
        <div className="rbdBasicInfo-container">
          <form className="rbdBasicInfo-form">
            <div className="rbdBasicInfo-group">
              <label>
                Mobile Number
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="tel"
                name="Mobile_no"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={10}
                value={isLoggedin ? mobileData : formData?.Mobile_no}
                disabled={isLoggedin}
                onChange={handleChange}
                readOnly={isOtpverified}
                autoComplete="off"
              />

              {errors?.Mobile_no && (
                <span
                  style={{ color: "red", fontSize: "14px" }}
                  className="error"
                >
                  {errors.Mobile_no}
                </span>
              )}
            </div>

            {showPatientType && (
              <div className="" style={{ width: "50%" }}>
                <label>Patient Type</label>
                <div style={{ display: "flex", gap: "1em", marginTop: 4 }}>
                  <label>
                    <input
                      type="radio"
                      name="patientType"
                      value="existing"
                      checked={patientType === "existing"}
                      onChange={() => {
                        setPatientType("existing");
                        setErrors({});
                      }}
                    />{" "}
                    Existing
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="patientType"
                      value="new"
                      checked={patientType === "new"}
                      onChange={() => {
                        setPatientType("new");
                        setSelectedPatient("");
                        setErrors({});
                        setFormData((prev) => ({
                          ...prev,
                          // keep the verified mobile_no
                          Mobile_no: prev.Mobile_no,

                          // reset everything else
                          FName: "",
                          LName: "",
                          Email: "",
                          Dateofbirth: "",
                          Gender: "M",
                          Alt_mobile_no: "",
                          address: "",
                          City: "",
                          landmark: "",
                          Zipcode: "",
                          preferredDate: "",
                          preferredTime: "",
                        }));
                      }}
                    />{" "}
                    New
                  </label>
                </div>
              </div>
            )}

            {profileData?.length > 0 && patientType === "existing" && (
              <div className="rbdBasicInfo-group">
                <label>Select Patient</label>
                <select onChange={handlePatientChange} value={selectedPatient}>
                  <option>---select Patient Name---</option>
                  {profileData?.map((profile, index) => (
                    <option key={profile.user_id} value={profile.user_id}>
                      {`${profile?.PFirstName} ${profile?.PLastName}`}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="rbdBasicInfo-group">
              <label>
                First name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                value={formData?.FName || ""}
                name="FName"
                onChange={handleChange}
                autoComplete="off"
                readOnly={patientType === "existing" && selectedPatient}
              />
              {errors?.FName && (
                <span
                  className="error"
                  style={{ color: "red", fontSize: "14px" }}
                >
                  {errors.FName}
                </span>
              )}
            </div>

            <div className="rbdBasicInfo-group">
              <label>
                Last name<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                value={formData?.LName || ""}
                name="LName"
                onChange={handleChange}
                autoComplete="off"
                readOnly={patientType === "existing" && selectedPatient}
              />
              {errors?.LName && (
                <span
                  className="error"
                  style={{ color: "red", fontSize: "14px" }}
                >
                  {errors.LName}
                </span>
              )}
            </div>

            <div className="rbdBasicInfo-group">
              <label>
                Email Address<span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                value={formData?.Email || ""}
                name="Email"
                autoComplete="off"
                onChange={handleChange}
              />
              {errors?.Email && (
                <span
                  className="error"
                  style={{ color: "red", fontSize: "14px" }}
                >
                  {errors.Email}
                </span>
              )}
            </div>

            <div className="rbdBasicInfo-group">
              <label>
                D.O.B<span style={{ color: "red" }}>*</span>
              </label>
              {/* <input
                type="date"
                value={(formData?.Dateofbirth)}
                name="Dateofbirth"
                autoComplete="off"
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
                readOnly={patientType === "existing" && selectedPatient}
              /> */}

              <DatePicker
                selected={formData.Dateofbirth}
                onChange={(date) =>
                  setFormData((prev) => ({ ...prev, Dateofbirth: date }))
                }
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                placeholderText="Date of Birth*"
                className="custom-date-input"
                readOnly={patientType === "existing" && selectedPatient}
              />
              {errors?.Dateofbirth && (
                <span
                  className="error"
                  style={{ color: "red", fontSize: "14px" }}
                >
                  {errors.Dateofbirth}
                </span>
              )}
            </div>

            <div className="rbdBasicInfo-group rbdBasicInfo-genderGroup">
              <label>
                Gender<span style={{ color: "red" }}>*</span>
              </label>
              <div className="rbdBasicInfo-genderOptions">
                <label>
                  <input
                    type="radio"
                    name="Gender"
                    value="M"
                    checked={formData?.Gender === "M"}
                    onChange={handleChange}
                  />{" "}
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="Gender"
                    value="F"
                    checked={formData?.Gender === "F"}
                    onChange={handleChange}
                  />{" "}
                  Female
                </label>
              </div>
              {/* {errors?.Gender && <span className="error" style={{ color: "red" ,fontSize: "14px"}}>{errors.Gender}</span>} */}
            </div>

            <div className="rbdBasicInfo-group ">
              <label>Alternative No(optional)</label>
              <input
                type="tel"
                name="Alt_mobile_no"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={10}
                value={formData?.Alt_mobile_no || ""}
                onChange={handleChange}
                autoComplete="off"
              />

              {errors?.Alt_mobile_no && (
                <span
                  className="error"
                  style={{ color: "red", fontSize: "14px" }}
                >
                  {errors.Alt_mobile_no}
                </span>
              )}
            </div>

            {/* <div className="rbdBasicInfo-group rbdBasicInfo-fullWidth">
                            <label>Attachment</label>
                            <input type="file" name="attachment" />
                        </div>

                        <div className="rbdBasicInfo-group rbdBasicInfo-fullWidth">
                            <label>Reasons for Visit</label>
                            <textarea name="reason" rows="3" />
                        </div> */}
          </form>
        </div>

        <hr
          style={{
            marginBottom: "1rem",
            marginTop: "1rem",
            border: "none",
            borderTop: "1px solid #e0e0e0",
            width: "100%",
            margin: "auto",
          }}
        />

        {/* Footer */}
        <div className="step1-footer-buttons">
          <button
            className="step1-back-btn rbdButton  reset-Btn reportBtn"
            onClick={onBack}
          >
            <span className="btn-text">
              <IoArrowBack className="step1-back-icon " /> Back
            </span>
          </button>
          <button
            className="step1-next-btn rbdButton "
            // onClick={onNext}
            onClick={handleBookAppointment}
          >
            <span className="btn-text">Book Now</span>
          </button>
        </div>
      </div>
    </>
  );
}
